import type { ReactNode } from "react";

/** A part of a text, from `start` to `end` (excluded), in UTF-16 units as `String.slice` counts them. */
export type TextRange = readonly [start: number, end: number];

/**
 * A text with the parts that answer a search marked (ADR-117). The app decides the parts, as its search compares;
 * the parts are sorted and do not overlap. The mark has a weight of its own, so it does not rest on colour alone.
 */
export function Highlight({ text, ranges }: { text: string; ranges: readonly TextRange[] }) {
  if (ranges.length === 0) return text;
  const parts: ReactNode[] = [];
  let at = 0;
  for (const [start, end] of ranges) {
    if (start > at) parts.push(text.slice(at, start));
    parts.push(
      <mark key={start} className="rounded-sm bg-highlight font-medium text-highlight-foreground">
        {text.slice(start, end)}
      </mark>,
    );
    at = end;
  }
  if (at < text.length) parts.push(text.slice(at));
  return parts;
}
